import setPopoutChildState from '../actions/setPopoutChildState';
import { parseMessage, PopoutMessageType, postMessage } from './crossWindowMessenger';
import { PopoutChildState } from '../store/schema/PopoutChildStore';
import { getStore } from '../store/childStore';

let internalContinueGetData: () => void;
let bypassContinueGetDataFromParentWindow: boolean = false;

export function continueGetDataFromParentWindow(): void {
    setPopoutChildState(PopoutChildState.Loading);
    if (internalContinueGetData) {
        internalContinueGetData();
    } else {
        // continueGetDataFromParentWindow was called before getDataFromParentWindow.
        // In this case, set the bypassContinueGetDataFromParentWindow flag so that getDataFromParentWindow
        // knows that it does not need to await for continueGetDataFromParentWindow() to be called
        bypassContinueGetDataFromParentWindow = true;
    }
}

export default async function getDataFromParentWindow<T>(
    deserializer?: (source: string) => T
): Promise<T | null> {
    if (!bypassContinueGetDataFromParentWindow) {
        await new Promise<void>(resolve => {
            internalContinueGetData = () => {
                resolve();
            };
        });
    }

    return getStore().isPopoutV2
        ? new Promise<T | null>(resolve => {
              const onMessage = (e: MessageEvent) => {
                  const message = parseMessage(e);

                  if (message && message.type == PopoutMessageType.SetData) {
                      window.removeEventListener('message', onMessage);
                      let data: T | null = null;
                      try {
                          data = deserializer
                              ? deserializer(message.serializedData)
                              : (JSON.parse(message.serializedData) as T);
                      } catch {}

                      resolve(data);
                  }
              };

              window.addEventListener('message', onMessage);

              try {
                  const w = window.opener;
                  postMessage(w, PopoutMessageType.PopoutReady, undefined);
              } catch {
                  resolve(null);
              }
          })
        : Promise.resolve(null);
}
